import { Link } from 'react-router-dom';

Link.displayName = 'Link';
export default Link;
